import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlSliderTrackColors = createInteractiveColorVar('controls-slider-track');
const ControlSliderTrackColorsLightValues = Object.freeze({
    default: '#000000',
    action: '#000000',
    active: '#000000',
    activeAction: '#000000',
});
const ControlSliderTrackColorsDarkValues = Object.freeze({
    default: '#ffffff',
    action: '#ffffff',
    active: '#ffffff',
    activeAction: '#ffffff',
});

export { ControlSliderTrackColors, ControlSliderTrackColorsDarkValues, ControlSliderTrackColorsLightValues };
